// extracted by mini-css-extract-plugin
export default {"left_menu":"LeftMenu_left_menu__13mob","active":"LeftMenu_active__NBSne","ant-menu-item-active":"LeftMenu_ant-menu-item-active__eqsR-"};